import type { Loan, PayPeriod, PaymentType } from '../types/payment';

export const standardPayPeriod: PayPeriod = {
  id: 'a0X1t000000AbCdEAG',
  name: 'EPP-004182 · Sarah Whitfield',
  employeeName: 'Sarah Whitfield',
  employeeRole: 'Senior Loan Officer · Northwest Team',
  startDate: '2026-08-01',
  endDate: '2026-08-15',
  commissionModel: 'standard',
  managerCommissionModel: 'standard',
  defaultCorpFee: 1250,
};

export const flatFeePayPeriod: PayPeriod = {
  ...standardPayPeriod,
  id: 'a0X1t000000AbCdFAG',
  name: 'EPP-004186 · Marcus Deleon',
  employeeName: 'Marcus Deleon',
  employeeRole: 'Loan Officer · Southeast Team',
  commissionModel: 'flat_fee',
  managerCommissionModel: 'flat_fee',
};

export const unsupportedPayPeriod: PayPeriod = {
  ...standardPayPeriod,
  id: 'a0X1t000000AbCdGAG',
  name: 'EPP-004190 · Renee Ortiz',
  employeeName: 'Renee Ortiz',
  employeeRole: 'Branch Manager · Mountain Team',
  commissionModel: 'unsupported',
  managerCommissionModel: 'unsupported',
};

export const loans: Loan[] = [
  {
    id: '006Ab0000012XyzAAA',
    name: 'Hollis Residence — Purchase',
    borrower: 'Daniel & Amy Hollis',
    loanNumber: 'LN-2026-10884',
    loanAmount: 612000,
    closeDate: '2026-08-04',
    grossCommission: 9180,
  },
  {
    id: '006Ab0000012XyzBBB',
    name: 'Bennett Refinance',
    borrower: 'Claudia Bennett',
    loanNumber: 'LN-2026-10902',
    loanAmount: 428500,
    closeDate: '2026-08-07',
    grossCommission: 6420,
  },
  {
    id: '006Ab0000012XyzCCC',
    name: 'Rivera Family — FHA Purchase',
    borrower: 'Miguel Rivera',
    loanNumber: 'LN-2026-10917',
    loanAmount: 315000,
    closeDate: '2026-08-11',
    grossCommission: 4725,
  },
  {
    id: '006Ab0000012XyzDDD',
    name: 'Castellanos Duplex — Investment',
    borrower: 'Ines Castellanos',
    loanNumber: 'LN-2026-10925',
    loanAmount: 744000,
    closeDate: '2026-08-13',
    grossCommission: 11160,
  },
  {
    id: '006Ab0000012XyzEEE',
    name: 'Okonkwo New Construction',
    borrower: 'Tobenna Okonkwo',
    loanNumber: 'LN-2026-10931',
    loanAmount: 889250,
    closeDate: '2026-08-14',
    grossCommission: 13338,
  },
];

export const expenseCategories = [
  'Office Rental',
  'Desk Rental',
  'Office Expenses',
  'Credit Reports',
  'Tech Fee',
  'Staff Payroll',
  'LOS Fee',
  'Insurance',
  'File Bonus Expense',
  'Other',
];

export interface PaymentTypeOption {
  id: PaymentType;
  label: string;
  description: string;
}

export const paymentTypeOptions: PaymentTypeOption[] = [
  {
    id: 'payment',
    label: 'Payment',
    description: 'Standard loan commission',
  },
  {
    id: 'referral',
    label: 'Referral Payment',
    description: 'Referral tied to a loan',
  },
  {
    id: 'manager_override',
    label: 'Manager Override',
    description: 'Override on a loan',
  },
  {
    id: 'recruiting_bonus',
    label: 'Recruiting Bonus',
    description: 'One-time bonus',
  },
  {
    id: 'expense',
    label: 'Expense',
    description: 'Pay period expense',
  },
  {
    id: 'other',
    label: 'Other',
    description: 'Misc. adjustment',
  },
];
